import { render, staticRenderFns } from "./CustomDisplayElementMemberRow.vue?vue&type=template&id=07cbcb40&scoped=true&lang=html"
import script from "./CustomDisplayElementMemberRow.vue?vue&type=script&lang=js"
export * from "./CustomDisplayElementMemberRow.vue?vue&type=script&lang=js"
import style0 from "./CustomDisplayElementMemberRow.vue?vue&type=style&index=0&id=07cbcb40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cbcb40",
  null
  
)

export default component.exports